import { colors } from 'settings/style';
import styled from 'styled-components';

const StyledText = styled.span`
  display: inline-block;
  color: ${colors.accent};
  cursor: pointer;
`;

export default StyledText;
